(function (fox, $) {
	"use strict";

	fox.registerWidget('CrowdFunding_Confirm', {
		
		configure: function () {
			this.paymentPending = [];
			this.minCustomPriceAmount = 2; //$
			this.recomendedCustomPriceAmount = 30; //$
			this.defErrors = {
				amount: 'Please enter amount',
				email: 'Please enter your email',
				login: 'Please enter your nickname'
			};

			this.registerOptions('', {
				'!template': 'popup_crowdfunding_confirm',
				widgets: {
					form: {
						widget: 'Form',
						loadValuesOnRun: true,
						autoApply: true,
						formElements: {
							message: {element: '[name=cf_message]'},
							amount: {element: '[name=amount]', defaultValue: this.recomendedCustomPriceAmount}
						},
						'hooks.onSubmit': '@parent:validateData'
					},
					prepareApi: {
						widget: 'Api',
						method: 'funds.prepare'
					}
				},

				handleWom: {
					inboxPayment: {
						widget: '@root #socket',
						event: ['inboxSocketEventFunds:billing:sale', 'inboxSocketEventFunds:billing:cancel', 'inboxSocketEventFunds:billing:action'],
						callback: '_handleSocketMessage'
					}
				},

				handleDom: {
					submit: {
						target: '.confirm',
						event: 'click',
						callback: '_submit'
					},
					focus: {
						target: 'input[type="text"]',
						event: 'focus',
						callback: function (el) {
							this.handleErrorToggle({state: true, el: el});
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.userData = {};
			this.api = null;
			
			var pm = fox.site.wom1('.PermissionManager');
			if (fox.isEmpty(pm.getMemberInfo())) {
				this.registerOptions('#form', {
					formElements: {
						'login.element': '[name=login]',
						'login.autoApply': true,
						'email.element': '[name=email]',
						'email.autoApply': true
					}
				});
			}
			this.callParent('init', arguments);
		},

		running: function() {
			this.prepareApi = this.rwom1('#prepareApi');

			this.handleEvent('#form', 'submit', fox.bind(this.onSubmit, this));
			this.callParent('running', arguments);
		},

		setFundId: function (id) {
			this.fundId = id;
		},

		_submit: function () {
			this.showCbWindow(
				new fox.Promise(resolve => {
					this.__prepareResolver = resolve;

					this.wom1('#form')._submit();
				})
			)
		},

		onSubmit: function (userData) {
			if (!this._isValid) {
				if (this.__prepareResolver)
					this.__prepareResolver(false);

				return false;
			}

			this.userData = userData;

			this.submit();
		},

		validateData: function () {
			this._isValid = false;
			var result = {
				email: false,
				login: false,
				amount: false
			};

			var pm = fox.site.wom1('.PermissionManager');
			if (fox.isEmpty(pm.getMemberInfo())) {
				result.email = this._validateEmail();
				result.name = this._validateName();
			} else {
				result.email = true;
				result.name = true;
			}

			result.amount = this._validateAmount();
			if (result.name && result.email && result.amount) {
				this._isValid = true;
				this.wom1('#form').dispatchEvent('submit', this.wom1('#form')._preparedValues);
				return;
			}
		},

		_validateAmount: function () {
			if (!this.wom1('#form #amount')) {
				return true;
			}

			var
				amount = this.wom1('#form').getValue('amount'),
				input = this.dom1('[name="amount"]'),
				regExp = /^[0-9]+(\.?[0-9]+)?$/;

			if (!input) {
				this.toggleError('amount', false);
				return false;
			}

			if (!amount || !amount.length || !amount.match(regExp)) {
				this.toggleError('amount', false);
				return false;
			}

			if (amount.match(regExp)) {
				amount = this.window.parseInt(amount);

				if (amount >= this.minCustomPriceAmount && amount <= 99999) {
					this.toggleError('amount', true);
					return true;
				}

				if (amount < this.minCustomPriceAmount) {
					this.toggleError('amount', false, 'Min donation amount is $2');
				}

				if (amount > 99999) {
					this.toggleError('amount', false, 'Max donation amount is $99,999');
				}

				return false;
			}

			return true;
		},

		_validateEmail: function () {
			var
				regExp = new RegExp('^[a-zA-Z0-9#\!\$%&\'\*\+\/=\?\^_`\{\}\|~-]+(?:\.[a-z0-9#\!\$%&\'\*\+\/=\?\^_`\{\}\|~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$'),
				el = this.dom1('[name="email"]', this.rwom1('#form').getContainer());

			if (!el) {
				return false;
			}

			if (this.isNotEmpty('email') && fox.trim(el.value).match(regExp)) {
				this.toggleError('email', true);
				return true;
			}

			this.toggleError('email', false);
			return false;
		},

		_validateName: function () {
			if (this.isNotEmpty('login')) {
				this.toggleError('login', true);
				return true;
			}

			this.toggleError('login', false);
			return false;
		},

		toggleError: function (name, state, msg) {
			var el = this.dom1('[name="' + name + '"]', this.rwom1('#form').getContainer());

			if (!el) {
				return;
			}

			fox.dom[(!state ? 'addClass' : 'removeClass')]('error', el);

			this.hookWrapper('handleErrorToggle', {state: state, el: el, msg: msg});
		},

		isNotEmpty: function (name) {
			return fox.trim(this.dom1('[name="' + name + '"]', this.rwom1('#form').getContainer()).value).length;
		},

		handleErrorToggle: function (data) {
			var msgContainer = $(data.el.parentNode).next();
			var state = data.state;
			fox.dom[(!state ? 'addClass' : 'removeClass')]('error', data.el);
			fox.dom[(!state ? 'addClass' : 'removeClass')]('error', data.el.parentNode);

			if (!state) {
				msgContainer.text(data.msg || this.defErrors[data.el.name]);

				return;
			}

			msgContainer.text('');
		},

		submit: function () {
			this.requireEmbeddedWidget('form').ignoreSubmit(true);

			var transactionParams = {
				fundId: this.fundId,
				amount: this.userData.amount
			};

			if (this.userData.login && this.userData.email) {
				transactionParams.login = fox.trim(this.userData.login);
				transactionParams.email = fox.trim(this.userData.email);
			}

			if (this.userData.message) {
				transactionParams.message = this.userData.message;
			}

			transactionParams = fox.mixin(transactionParams, this.getOption('preparedTransactionParams'));

			this.prepareTransaction(transactionParams)
				.then(fox.bind(function (res) {
					this.onPrepareSuccess(res, transactionParams.tipId);
				}, this))
				.catch(fox.bind(this.onPrepareFailed, this));
		},

		prepareTransaction: function(formData) {
			this.wom1('@parent').hide();

			this.prepareTransactionInProgress = true;

			return this.prepareApi.psend(formData);
		},

		onPrepareFailed: function (err, api, e) {
			this.prepareTransactionInProgress = false;
			this.dispatchEvent('prepareFailed', err);

			console.error('onPrepareFailed', err);
		},

		onPrepareSuccess: function (r, tipId) {
			this.prepareTransactionInProgress = false;

			function pendingPayment (tipId) {
				this.rwom1('#form')
					.enableAllElements()
					.ignoreSubmit(false);

				this.paymentPending.push(Number(tipId));
			}

			r = r.params.answer.response;

			if (r.submit_url) {
				if (this.__prepareResolver)
					this.__prepareResolver(r);

				return pendingPayment.call(this, tipId);
			} else if (r === true || r === 'Event successfully processed') {
				return pendingPayment.call(this, tipId);
			}

			throw new Error('Payment error');
		},

		showCbWindow: function (promise) {
			var cbPopup = this.wom1('#cbPaymentPopup');

			if (!cbPopup) {
				cbPopup = this.embedWidget('cbPaymentPopup', 'CBPaymentPopup', {});

				cbPopup.run();
			}

			cbPopup.show(promise.then(data => {
				this.__prepareResolver = null;

				if (data === false)
					cbPopup.hide();

				const url = data.submit_url + '?' + fox.toQueryString(data.added_fields);

				return { url };
			}));
		},

		_handleSocketMessage: function (obj) {}

	}, 'Widget');

})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/crowdfunding/confirm.es.js